import { Menu, MenuItem } from "@mui/material";
import i18next from "i18next";
import React, { useState } from "react";
import { allowedLanguages } from "../../constant-Utils";
// @ts-ignore
import { LANGUAGES } from "../../../base/i18n";
import { useDispatch } from "react-redux";
// @ts-ignore
import { hideApiLoader, showApiLoader } from "../../redux/tool-webjam/actions";
// @ts-ignore
import { getBaseConfig } from "../../Utils";
// @ts-ignore
import { updateUserLanguage } from "../Request.d";
// @ts-ignore
import { sortLanguageAlphabetically } from "../../custom/components/HelperComponent";
export const LanguageSelect = () => {
    const dispatch = useDispatch();
    const handleChange = async (e) => {
        dispatch(showApiLoader());
        i18next.changeLanguage(e);
        let timer = null;
        if (timer)
            clearTimeout(timer);
        timer = setTimeout(() => {
            dispatch(hideApiLoader(1));
        }, 2000);
        await updateUserLanguage({ language: e });
    };
    const languageItems = LANGUAGES.map((language) => {
        return {
            value: language,
            label: i18next.t(`languages:${language}`),
        };
    })
        .filter((e) => e.value !== "default" && allowedLanguages.includes(e.value))
        .sort(sortLanguageAlphabetically);
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (value) => {
        setAnchorEl(null);
        if (value && typeof value === "string") {
            handleChange(value);
        }
    };
    if (!getBaseConfig("showLanguageDropdown")) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "language-select-wrapper", style: { marginTop: "-5px" } },
            React.createElement("div", { className: "d-flex", style: { alignItems: "center" } },
                React.createElement("img", { "aria-controls": open ? "basic-menu" : undefined, "aria-haspopup": "true", "aria-expanded": open ? "true" : undefined, onClick: handleClick, height: 35, width: 35, src: getBaseConfig("languageIcon") })),
            open && (React.createElement(Menu, { transitionDuration: 0, className: `language-select language-select-landscape`, id: "basic-menu", anchorEl: anchorEl, open: open, onClose: handleClose, MenuListProps: {
                    "aria-labelledby": "basic-button",
                } }, languageItems.map((l, i) => (React.createElement(MenuItem, { dense: true, style: { fontSize: "14px" }, selected: l.value === i18next.language, onClick: () => handleClose(l.value), key: i, value: l.value }, l.label))))))));
};
